import React from "react";
import { usePageContext } from "@/contexts/Page";
import { translations } from "@/lib/translations";

interface TranslateProps {
  id: string;
}

export const Translate: React.FC<TranslateProps> = ({ id }) => {
  const { language } = usePageContext();

  return <span translate="no">{translations[language][id]}</span>;
};
